<div class="wrapper">
  @for (resource of resourceList(); track resource.guid) {
    <div class="accordion" [class.expanded]="isItemExpanded(resource.guid)">
      <div
        class="accordion-header"
        role="button"
        tabindex="0"
        [attr.aria-expanded]="isItemExpanded(resource.guid)"
        (click)="expandShrinkGroup(resource.guid)"
        (keydown.enter)="expandShrinkGroup(resource.guid)"
        (keydown.space)="expandShrinkGroup(resource.guid); $event.preventDefault()"
      >
        <div class="header-content">
          <div class="status-row">
            @switch (resource.locationState) {
              @case (locationStateEnum.Accepted) {
                <span class="accepted">{{ translation.common.accepted | transloco }}</span>
              }
              @case (locationStateEnum.Confirmed) {
                <span class="accepted">{{ translation.common.confirmed | transloco }}</span>
              }
              @case (locationStateEnum.Tentative) {
                <span class="tentative">{{ translation.common.tentative | transloco }}</span>
              }
              @case (locationStateEnum.Declined) {
                <span class="declined">{{ translation.common.declined | transloco }}</span>
              }
              @case (locationStateEnum.NeedConfirmation) {
                <span class="need-confirmation">{{ translation.common.needConfirmation | transloco }}</span>
              }
              @case (locationStateEnum.ConfirmNow) {
                <span class="confirm-now">{{ translation.common.confirmNow | transloco }}</span>
              }
              @case (locationStateEnum.ReleasedForNonConfirmation) {
                <span class="released-for-nonconfirmation">{{ translation.common.released | transloco }}</span>
              }
              @case (locationStateEnum.ReleasedForNonConfirmationFailed) {
                <span class="released-for-nonconfirmation-failed">{{
                  translation.common.releaseFailed | transloco
                }}</span>
              }
              @case (locationStateEnum.Unconfirmed) {
                <span class="unconfirmed">{{ translation.common.unconfirmed | transloco }}</span>
              }
            }
          </div>
          <div class="title-row">
            <p class="heading">
              {{ resource.resourceDisplayNameForApp ?? resource.displayName }}
            </p>
            <div class="end-part">
              <div class="arrow">
                <cue-icon [icon]="ICONS.cueArrowDown"></cue-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      @if (isItemExpanded(resource.guid)) {
        <div class="accordion-content">
          <addin-resource-detail [start]="start()" [end]="end()" [resource]="resource"> </addin-resource-detail>
        </div>
      }
    </div>
  }
</div>
